import React from 'react';

function Footer() {
    return (
        <footer style={{ background: "var(--glaze)", padding: "40px 20px", textAlign: "center", color: "var(--text-dark)", marginTop: "auto", borderTop: "1px solid var(--border-glaze)" }}>
            <p style={{ fontSize: "14px", opacity: 0.8, letterSpacing: "0.5px" }}>
                Designed and Built by <span style={{ color: "var(--ozone)", fontWeight: "600" }}>Arabella Nipay Resaba</span>
            </p>
            <p style={{ fontSize: "12px", opacity: 0.5, marginTop: "8px" }}>© {new Date().getFullYear()} All Rights Reserved.</p>
        </footer>
    );
}

export default Footer;
